import React from 'react'
import SocialMediaLink from './SocialMediaLink';


const SocialMediaLinkList = ({socialmediaData}) => (
    Object.keys(socialmediaData).map((socialMediaId, index) => (
        socialmediaData[socialMediaId] && <SocialMediaLink 
            key={index}
            type={socialMediaId}
            url={socialmediaData[socialMediaId]}
        />
    ))
)

export default SocialMediaLinkList